import PayStubOperation from './pay-stubs-operations';
import ResidencyOperations from './residency-operations';
import VerificationDocumentsOperations from './verification-documents-operations';

const GetDocumentOperations = type => {
  switch (type) {
    case 'PayStub':
      return PayStubOperation;
    case 'Residency':
      return ResidencyOperations;
    default:
      return VerificationDocumentsOperations;
  }
};

export default GetDocumentOperations;
